import { Box, Grid } from "@mui/material";
import { SubmitHandler, useForm } from "react-hook-form";
import Input from "../../../components/input/Input-v2";
import { LoadingButton } from "../../../components/button/Button";
import {
  useAddSupplier,
  useGetSupplier,
  useUpdateSupplier,
} from "../api/supplier/resolver";
import { useEffect } from "react";

interface Form {
  idSupplier?: string;
}

export interface Form_Supplier {
  supplier_name: string;
  supplier_phone_number: string;
  supplier_address: string;
}

export interface Form_Update_Supplier extends Form_Supplier {
  supplier_id: string;
}

export default function Form({ idSupplier }: Form) {
  const { mutate: mutateAddSupplier, isLoading: loadingAddSupplier } =
    useAddSupplier();
  const { mutate: mutateUpdateSupplier, isLoading: loadingUpdateSupplier } =
    useUpdateSupplier();
  const { data: dataRawSupplier, isLoading: loadingFetchSupplier } =
    useGetSupplier({ supplier_id: idSupplier });
  const dataSupplier = dataRawSupplier?.data?.data;
  const isAddFlow = idSupplier === undefined;
  const isLoading = loadingAddSupplier || loadingUpdateSupplier;
  const { control, handleSubmit, setValue } = useForm<Form_Supplier>({
    defaultValues: {
      supplier_address: "",
      supplier_name: "",
      supplier_phone_number: "",
    },
  });

  useEffect(() => {
    if (dataSupplier) {
      setValue("supplier_address", dataSupplier.supplier_address);
      setValue("supplier_name", dataSupplier.supplier_name);
      setValue("supplier_phone_number", dataSupplier.supplier_phone_number);
    }
  }, [dataSupplier]);

  const handleFormSubmit: SubmitHandler<Form_Supplier> = (data) => {
    if (isAddFlow) {
      mutateAddSupplier({ ...data });
    } else {
      const body: Form_Update_Supplier = {
        supplier_id: idSupplier,
        ...data,
      };
      mutateUpdateSupplier({ ...body });
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="supplier_name"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Text
                  label="Nama Supplier"
                  isFetching={loadingFetchSupplier}
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="supplier_phone_number"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Text
                  label="Telp Supplier"
                  isFetching={loadingFetchSupplier}
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Input.Controller
              control={control}
              name="supplier_address"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.TextArea
                  row={10}
                  label="Alamat Supplier"
                  isFetching={loadingFetchSupplier}
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid
            item
            xs={12}
            display={"flex"}
            justifyContent={"flex-end"}
            gap={2}
          >
            {!isAddFlow && <LoadingButton color="error" text="Hapus" />}
            <LoadingButton
              type="submit"
              isLoading={isLoading}
              text={isAddFlow ? "Tambah" : "Update"}
            />
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
